import { render, staticRenderFns } from "./ListBnAvoirFour.vue?vue&type=template&id=34588002&"
import script from "./ListBnAvoirFour.vue?vue&type=script&lang=js&"
export * from "./ListBnAvoirFour.vue?vue&type=script&lang=js&"
import style0 from "./ListBnAvoirFour.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports